var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlossaryActive = function SvgGlossaryActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M5 6h14v15H7a2 2 0 0 1-2-2V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M5 6a2 2 0 0 1 2-2h12v4H7a2 2 0 0 1-2-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 13V8h3v5l-1.5-1.5L14 13Z"
  })));
};
export default SvgGlossaryActive;